import styled, { css } from 'styled-components';
import { HashLink as RouterLink } from 'react-router-hash-link';

import { Media } from 'assets/Mixins.style';

export const Wrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: none;
  width: 100%;
  padding: ${props => props.theme.padding.default};
  margin-top: -1px;
  background: ${props => props.theme.background.default};
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius};
  z-index: +2;

  ${Media.lg`
    position: relative;
    top: initial;
    left: initial;
    right: initial;
    margin-top: initial;
    box-shadow: none;
    z-index: initial;
    padding: ${props => props.theme.padding.lg};
    background: ${props => props.theme.background.lg};
  `}

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}


  ${props =>
    props.opened &&
    css`
      display: block;
    `}
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 15px;

  ${Media.md`
    grid-template-columns: 1fr;
  `}
`;

export const Main = styled.div`
  display: block;
  width: 100%;
  min-width: 720px;

  ${Media.lg`
    min-width: auto;
  `}

  ${props =>
    props.theme &&
    props.theme.padding &&
    css`
      padding: ${props => props.theme.padding.default};

      ${Media.lg`
        padding: ${props => props.theme.padding.lg};
      `}

      ${Media.md`
        padding: ${props => props.theme.padding.md};
      `}
    `}
`;

export const Aside = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${props => props.theme.maxWidth};
  width: 100%;
  height: 100%;
  border-left: 1px solid ${props => props.theme.border};

  ${Media.md`
    max-width: 100%;
    border-left: none;
  `}

  ${props =>
    props.theme &&
    props.theme.background &&
    css`
      background: ${props => props.theme.background.default};

      ${Media.lg`
        background: ${props => props.theme.background.lg};
      `}
    `}

  ${props =>
    props.theme &&
    props.theme.boxShadow &&
    css`
      box-shadow: ${props => props.theme.boxShadow.default};

      ${Media.lg`
        box-shadow: ${props => props.theme.boxShadow.lg};
      `}
    `}

  ${props =>
    props.theme &&
    props.theme.padding &&
    css`
      padding: ${props => props.theme.padding.default};

      ${Media.lg`
        padding: ${props => props.theme.padding.lg};
      `}

      ${Media.md`
        padding: ${props => props.theme.padding.md};
      `}
    `}
`;

export const Title = styled.h3`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const TitleLink = styled(RouterLink)`
  color: inherit;
`;
export const TitleLinkExternal = styled.a`
  color: inherit;
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 55px;

  ${Media.md`
    grid-template-columns: 1fr;
  `}
`;

export const Item = styled(RouterLink)`
  display: grid;
  align-items: center;
  grid-template-columns: 50px 1fr;
  grid-gap: 10px;
  padding: ${props => props.theme.padding.default};
  border-bottom: 1px solid ${props => props.theme.border};
  transition: 0.2s all;
  cursor: pointer;

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}

  &:first-of-type {
    ${Media.md`
      border-top: 1px solid ${props => props.theme.border};
    `}
  }

  &:nth-last-of-type(2) {
    border-bottom: 0;

    ${Media.md`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }

  &:nth-last-of-type(1) {
    border-bottom: 0;

    ${Media.md`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }
`;

export const ItemExternal = styled.a`
  display: grid;
  align-items: center;
  grid-template-columns: 50px 1fr;
  grid-gap: 10px;
  padding: ${props => props.theme.padding.default};
  border-bottom: 1px solid ${props => props.theme.border};
  transition: 0.2s all;
  cursor: pointer;

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}

  &:first-of-type {
    ${Media.md`
      border-top: 1px solid ${props => props.theme.border};
    `}
  }

  &:nth-last-of-type(2) {
    border-bottom: 0;

    ${Media.md`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }

  &:nth-last-of-type(1) {
    border-bottom: 0;

    ${Media.md`
      border-bottom: 1px solid ${props => props.theme.border};
    `}
  }
`;

export const Imagebox = styled.div`
  display: block;
  width: 50px;
  height: 50px;
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${props => props.theme.borderRadius.default};

  ${Media.md`
    border-radius: ${props => props.theme.borderRadius.md};
  `}
`;

export const Text = styled.h3`
  display: block;
  width: 100%;
  transition: 0.2s all;
  color: ${props => props.theme.color};
  background: ${props => props.theme.background};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  &:hover{
    color: ${props => props.theme.colorOnHover};
    background: ${props => props.theme.backgroundOnHover};
  }

  ${props =>
    props.active &&
    css`
      color: ${props => props.theme.colorOnActive};
      background: ${props => props.theme.backgroundOnActive};
    `}
`;

export const Arrow = styled.i`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 5px;
  color: ${props => props.theme.color};
  vertical-align: middle;
  transition: 0.2s all;

  ${Item}:hover &,
  ${ItemExternal}:hover & {
    color: ${props => props.theme.colorOnHover};
  }
`;
